// Create a new file ItemizedVehicles.jsx
import React, { Component } from 'react';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Select from 'react-validation/build/select';
import { required, isNumeric, isCurrency } from "../../../util/validationMethods";

class ItemizedVehicles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newVehicle: {
        vin: '',
        plate: '',
        year: '',
        make: '',
        model: '',
        color: '',
        note: ''
      }
    };
  }

  // Prevent re-renders due to form validation
  shouldComponentUpdate(nextProps, nextState) {
    // Only update if vehicles array changes or newVehicle state changes
    if (JSON.stringify(this.props.vehicles) !== JSON.stringify(nextProps.vehicles) ||
        JSON.stringify(this.state.newVehicle) !== JSON.stringify(nextState.newVehicle) ||
        this.props.isDisabled !== nextProps.isDisabled ||
        JSON.stringify(this.props.ratePlan) !== JSON.stringify(nextProps.ratePlan)) {
      return true;
    }
    return false;
  }

  onUpdateTowCharge = (newVehicles) => {
    // Calculate the total tow charge based on the updated vehicles array 
    let towCharge = newVehicles.reduce((sum, v) => sum + (parseFloat(v.hookCharge) || 0), 0)

    // Update towCharge
    this.props.onUpdateTowCharge(towCharge);
  }

  handleAddVehicle = () => {
    // Create a copy of the current vehicles array
    const newVehicles = [...this.props.vehicles];
    
    // Add the new vehicle with hook charge from the rate plan
    const vehicleToAdd = {
      ...this.state.newVehicle,
      hookCharge: this.props.ratePlan?.service_flat_rate || 0,
      mileageCharge: 0
    };
    
    newVehicles.push(vehicleToAdd);
    
    // Pass the updated array to the parent
    this.props.onUpdateVehicles(newVehicles);

    // Update the tow charge
    this.onUpdateTowCharge(newVehicles);
    
    // Reset the form
    this.setState({
      newVehicle: {
        vin: '',
        plate: '',
        year: '',
        make: '',
        model: '',
        color: '',
        note: ''
      }
    });
  }

  handleDeleteVehicle = (index) => {
    const newVehicles = [...this.props.vehicles];
    newVehicles.splice(index, 1);
    this.props.onUpdateVehicles(newVehicles);

    // Update the tow charge
    this.onUpdateTowCharge(newVehicles);
  }

  handleChange = (field, value) => {
    this.setState(prevState => ({
      newVehicle: {
        ...prevState.newVehicle,
        [field]: value
      }
    }));
  }

  handleVehicleChange = (index, field, value) => {
    // Create a copy of the current vehicles array
    const newVehicles = [...this.props.vehicles];
    
    // Update the specific field in a safe way
    if (newVehicles[index]) {
      newVehicles[index] = {
        ...newVehicles[index],
        [field]: value
      };
      
      // Pass the updated array to the parent
      this.props.onUpdateVehicles(newVehicles);

      // Update the tow charge
      this.onUpdateTowCharge(newVehicles);
    }
  }

  render() {
    const { vehicles = [], isDisabled, ratePlan } = this.props;
    const { newVehicle } = this.state;
    
    return (
      <div className="itemized-vehicles-container">
        <h6 className="text-blue text-bg-color form-group">Itemized Vehicles</h6>
        
        <div className="table-responsive">
          <table className="table table-bordered table-hover">
            <thead className="thead-light">
              <tr>
                <th>VIN</th>
                <th>Plate</th>
                <th>Year</th>
                <th>Make</th>
                <th>Model</th>
                <th>Color</th>
                <th>Note</th>
                <th>Hook Charge</th>
                {/* <th>Mileage Charge</th> */}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(vehicles) && vehicles.map((vehicle, index) => (
                <tr key={`vehicle-${index}`}>
                  <td>
                    <input 
                      type="text" 
                      className="form-control form-control-sm"
                      value={vehicle.vin || ''}
                      disabled={isDisabled}
                      onChange={(e) => this.handleVehicleChange(index, 'vin', e.target.value)}
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      className="form-control form-control-sm"
                      value={vehicle.plate || ''}
                      disabled={isDisabled}
                      onChange={(e) => this.handleVehicleChange(index, 'plate', e.target.value)}
                    />
                  </td>
                  <td>
                    <input 
                      type="number" 
                      className="form-control form-control-sm"
                      value={vehicle.year || ''}
                      disabled={isDisabled}
                      onChange={(e) => {
                        if (/^\d{0,4}$/.test(e.target.value)) {
                        this.handleVehicleChange(index, 'year', e.target.value)
                        }
                      }}
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      className="form-control form-control-sm"
                      value={vehicle.make || ''}
                      disabled={isDisabled}
                      onChange={(e) => this.handleVehicleChange(index, 'make', e.target.value)}
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      className="form-control form-control-sm"
                      value={vehicle.model || ''}
                      disabled={isDisabled}
                      onChange={(e) => this.handleVehicleChange(index, 'model', e.target.value)}
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      className="form-control form-control-sm"
                      value={vehicle.color || ''}
                      disabled={isDisabled}
                      onChange={(e) => this.handleVehicleChange(index, 'color', e.target.value)}
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      className="form-control form-control-sm"
                      value={vehicle.note || ''}
                      disabled={isDisabled}
                      onChange={(e) => this.handleVehicleChange(index, 'note', e.target.value)}
                    />
                  </td>
                  <td>
                    <input 
                      type="number" 
                      className="form-control form-control-sm"
                      value={vehicle.hookCharge || 0}
                      disabled={isDisabled}
                      onChange={(e) => this.handleVehicleChange(index, 'hookCharge', parseFloat(e.target.value) || 0)}
                    />
                  </td>
                  {/* <td>
                    <input 
                      type="number" 
                      className="form-control form-control-sm"
                      value={vehicle.mileageCharge || 0}
                      disabled={isDisabled}
                      onChange={(e) => this.handleVehicleChange(index, 'mileageCharge', parseFloat(e.target.value) || 0)}
                    />
                  </td> */}
                  <td>
                    <button 
                      type="button" 
                      className="btn btn-danger btn-sm"
                      disabled={isDisabled}
                      onClick={() => this.handleDeleteVehicle(index)}
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
              
              {/* Add new vehicle row */}
              <tr>
                <td>
                  <input 
                    type="text" 
                    className="form-control form-control-sm"
                    value={newVehicle.vin || ''}
                    disabled={isDisabled}
                    onChange={(e) => this.handleChange('vin', e.target.value)}
                    placeholder="VIN"
                  />
                </td>
                <td>
                  <input 
                    type="text" 
                    className="form-control form-control-sm"
                    value={newVehicle.plate || ''}
                    disabled={isDisabled}
                    onChange={(e) => this.handleChange('plate', e.target.value)}
                    placeholder="Plate"
                  />
                </td>
                <td>
                  <input 
                    type="number" 
                    className="form-control form-control-sm"
                    value={newVehicle.year || ''}
                    disabled={isDisabled}
                    onChange={(e) => {
                      if (/^\d{0,4}$/.test(e.target.value)) {
                      this.handleChange('year', e.target.value)
                      }
                    }}
                    placeholder="Year"
                  />
                </td>
                <td>
                  <input 
                    type="text" 
                    className="form-control form-control-sm"
                    value={newVehicle.make || ''}
                    disabled={isDisabled}
                    onChange={(e) => this.handleChange('make', e.target.value)}
                    placeholder="Make"
                  />
                </td>
                <td>
                  <input 
                    type="text" 
                    className="form-control form-control-sm"
                    value={newVehicle.model || ''}
                    disabled={isDisabled}
                    onChange={(e) => this.handleChange('model', e.target.value)}
                    placeholder="Model"
                  />
                </td>
                <td>
                  <input 
                    type="text" 
                    className="form-control form-control-sm"
                    value={newVehicle.color || ''}
                    disabled={isDisabled}
                    onChange={(e) => this.handleChange('color', e.target.value)}
                    placeholder="Color"
                  />
                </td>
                <td>
                  <input 
                    type="text" 
                    className="form-control form-control-sm"
                    value={newVehicle.note || ''}
                    disabled={isDisabled}
                    onChange={(e) => this.handleChange('note', e.target.value)}
                    placeholder="Note"
                  />
                </td>
                <td>
                  <div className="text-center">
                    <span className="d-block mb-1">Default Hook: ${ratePlan?.service_flat_rate || 0}</span>
                  </div>
                </td>
                <td>
                  <button 
                    type="button" 
                    className="btn btn-success btn-sm"
                    disabled={isDisabled || !newVehicle.make}
                    onClick={this.handleAddVehicle}
                  >
                    <i className="fa fa-plus"></i> Add
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="7" className="text-right"><strong>Total:</strong></td>
                <td>
                  <strong>
                    ${(Array.isArray(vehicles) ? vehicles.reduce((sum, v) => sum + (parseFloat(v.hookCharge) || 0), 0) : 0).toFixed(2)}
                  </strong>
                </td>
                {/* <td>
                  <strong>
                    ${(Array.isArray(vehicles) ? vehicles.reduce((sum, v) => sum + (parseFloat(v.mileageCharge) || 0), 0) : 0).toFixed(2)}
                  </strong>
                </td> */}
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  }
}

export default ItemizedVehicles;